import { useState } from 'react';
import './signup.css';
import lockShieldImg from '../assets/icon.png';

function ChevronLeftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IndiaFlagIcon() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" className="signup-flag">
      <rect width="20" height="14" rx="2" fill="#fff" />
      <path d="M0 2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2.33H0V2Z" fill="#FF9933" />
      <path d="M0 9.33h20V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V9.33Z" fill="#128807" />
      <circle cx="10" cy="7" r="1.9" fill="none" stroke="#000088" strokeWidth="0.3" />
      <circle cx="10" cy="7" r="0.3" fill="#000088" />
    </svg>
  );
}

function ChevronDownIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function PhoneIcon({ active }) {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path
        d="M6.6 10.8c1.4 2.7 3.7 5 6.4 6.4l2.1-2.1c.3-.3.7-.4 1.1-.2 1.1.4 2.3.6 3.5.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.9 21 3 13.1 3 3.3c0-.6.4-1 1-1H7.3c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.5.1.4 0 .8-.2 1.1L6.6 10.8Z"
        fill={active ? '#ffffff' : 'none'}
        stroke={active ? '#ffffff' : '#8a84a3'}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MailIcon({ active }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="5" width="18" height="14" rx="3" stroke={active ? '#ffffff' : '#8a84a3'} strokeWidth="1.8" />
      <path d="M4 7l8 6 8-6" stroke={active ? '#ffffff' : '#8a84a3'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function FieldMailIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="5" width="18" height="14" rx="3" stroke="#8a6df1" strokeWidth="1.8" />
      <path d="M4 7l8 6 8-6" stroke="#8a6df1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function Signup({ onSwitchToLogin, onBack, onContinue }) {
  const [method, setMethod] = useState('phone');
  const [agreed, setAgreed] = useState(false);
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');

  return (
    <div className="signup-screen">
      <div className="signup-frame">
        <div className="signup-header">
          <button type="button" className="signup-back-btn" onClick={onBack} aria-label="Go back">
            <ChevronLeftIcon />
          </button>

          <div className="signup-glow" />
          <div className="signup-icon-wrap">
            <img src={lockShieldImg} alt="" className="signup-icon-img" />
          </div>
          <h1 className="signup-title">Create your account</h1>
          <p className="signup-subtitle">Sign up to get started with us</p>
        </div>

        <form
          className="signup-card"
          onSubmit={(e) => {
            e.preventDefault();
            if (!agreed) return;
            const contact = method === 'phone' ? `+91 ${phone}` : email;
            onContinue?.({ method, contact });
          }}
        >
          <p className="signup-section-label">Sign up with</p>

          <div className="signup-toggle">
            <button
              type="button"
              className={`signup-toggle-btn ${method === 'phone' ? 'active' : ''}`}
              onClick={() => setMethod('phone')}
            >
              <PhoneIcon active={method === 'phone'} />
              Phone Number
            </button>
            <button
              type="button"
              className={`signup-toggle-btn ${method === 'email' ? 'active' : ''}`}
              onClick={() => setMethod('email')}
            >
              <MailIcon active={method === 'email'} />
              Email Address
            </button>
          </div>

          {method === 'phone' ? (
            <>
              <div className="signup-field">
                <label className="signup-label" htmlFor="phone">
                  Phone Number
                </label>
                <div className="signup-input-wrap">
                  <button type="button" className="signup-country">
                    <IndiaFlagIcon />
                    +91
                    <ChevronDownIcon />
                  </button>
                  <span className="signup-divider-bar" />
                  <input
                    id="phone"
                    type="tel"
                    placeholder="Enter your phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
              </div>
              <p className="signup-hint">We&apos;ll send you a verification code</p>
            </>
          ) : (
            <>
              <div className="signup-field">
                <label className="signup-label" htmlFor="signup-email">
                  Email Address
                </label>
                <div className="signup-input-wrap">
                  <FieldMailIcon />
                  <input
                    id="signup-email"
                    type="email"
                    placeholder="example@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <p className="signup-hint">We&apos;ll send you a verification link</p>
            </>
          )}

          <label className="signup-consent">
            <input
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
            <span>
              I agree to the Terms &amp; Conditions and Privacy and DPDP policy.
              Required for account creation.
            </span>
          </label>

          <button type="submit" className="signup-submit" disabled={!agreed}>
            Continue <ArrowRightIcon />
          </button>

          <p className="signup-login-row">
            Already have an account?
            <button type="button" onClick={onSwitchToLogin}>
              Log in
            </button>
          </p>
        </form>
      </div>
    </div>
  );
}
